module.exports = __webpack_public_path__ + "img/pr-13.7db92ab9.png";